// extracted by mini-css-extract-plugin
export default {"classes":"Spinner_classes__0wT-9"};